import { DateTimeField, TextField, theme } from '@mi-front/ui';
import HelpIcon from '@mui/icons-material/Help';
import { useFormikContext } from 'formik';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { SearchHelpModal } from './HelpModal';

export function SearchForm() {
  const { $t } = useIntl();
  const tz = useTimezone();
  const [show, setShow] = useState(false);
  const fp = useFormikContext<{ _format: string }>();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        fp.submitForm();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const onShow = () => {
    setShow(true);
  };

  const onHide = () => {
    setShow(false);
  };

  return (
    <>
      <div className="row">
        <div className="col-4">
          <DateTimeField
            name="from"
            dateLabel={$t({
              id: 'common.dateStart',
              defaultMessage: 'Fecha inicio',
            })}
            timeLabel={$t({
              id: 'common.timeStart',
              defaultMessage: 'Hora inicio',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
        <div className="col-4">
          <DateTimeField
            name="to"
            dateLabel={$t({
              id: 'common.dateEnd',
              defaultMessage: 'Fecha fin',
            })}
            timeLabel={$t({
              id: 'common.timeEnd',
              defaultMessage: 'Hora fin',
            })}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <TextField name="input" />
        </div>
        <div onClick={onShow}>
          <HelpIcon
            style={{
              marginTop: '0.5rem',
              color: theme.gray600,
            }}
          />
        </div>
      </div>
      <SearchHelpModal show={show} onHide={onHide} />
    </>
  );
}
